export const GET_ALL_RESOURCES = 'GET_ALL_RESOURCES';
export const GET_RESOURCE_BY_ID = 'GET_RESOURCE_BY_ID';
export const SET_RESOURCE_BY_ID = 'SET_RESOURCE_BY_ID';
export const DELETE_RESOURCE = 'DELETE_RESOURCE';
export const SET_RESOURCES = 'SET_RESOURCES';
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE';
export const CREATE_RESOURCE = 'CREATE_RESOURCE';
